/**
 * Same rules as functions/src/lib/internalTesters.ts.
 * Testers use @demo.prairi.com, INTERNAL_TEST, INTERNAL_TEST_STRIPE, DEMO_USER,
 * or the named inbox hoorieh.23@gmail.com.
 */
const INTERNAL_TESTER_PROMO_CODES = new Set(['INTERNAL_TEST', 'INTERNAL_TEST_STRIPE', 'DEMO_USER']);
const INTERNAL_TESTER_EMAILS = new Set(['hoorieh.23@gmail.com']);

/** Flip to true when the PRAIRI inbox thread should go to every investor and startup. */
export const PRAIRI_INBOX_THREAD_LIVE = false;

/** QA inboxes that can see the thread while it is not live for users. */
const PRAIRI_THREAD_QA_EMAILS = new Set(['hoorieh.23@gmail.com', 'hoorieh.23+2@gmail.com']);

export function isInternalTesterAccount(
  user?: {
    isTest?: boolean | null;
    email?: string | null;
    promoCode?: string | null;
  } | null
): boolean {
  if (!user) return false;
  if (user.isTest === true) return true;
  const email = (user.email || '').trim().toLowerCase();
  if (INTERNAL_TESTER_EMAILS.has(email) || email.endsWith('@demo.prairi.com')) return true;
  const promo = (user.promoCode || '').trim().toUpperCase();
  return INTERNAL_TESTER_PROMO_CODES.has(promo);
}

/** PRAIRI inbox thread. Hidden from users until PRAIRI_INBOX_THREAD_LIVE is true. */
export function canSeePrairiThread(
  user?: {
    isTest?: boolean | null;
    email?: string | null;
    promoCode?: string | null;
  } | null
): boolean {
  if (!user) return false;
  const email = (user.email || '').trim().toLowerCase();
  if (PRAIRI_THREAD_QA_EMAILS.has(email)) return true;
  if (!PRAIRI_INBOX_THREAD_LIVE) return false;
  return isInternalTesterAccount(user);
}
